import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <h1 className="text-3xl font-bold">Privacy Policy Page</h1>
    </div>
  );
};

export default PrivacyPolicy;
